import { combineReducers } from 'redux';

import { SELECT_DEALER } from 'constants/ActionTypes';
import createSearchReducers from 'modules/global/reducers/simpleSearchReducer';
import { SELECT_GROUP } from 'modules/groups/actionTypes';
import {
  DELETE_MEDIA_LIBRARY_SUCCESS,
  FETCH_MEDIA_LIBRARY,
  SET_MEDIA_LIBRARY_FILTER,
  UPLOAD_MEDIA_LIBRARY_ITEMS_SUCCESS,
} from 'modules/mediaLibrary/actionTypes';
import { DEALER_MODE, GROUP_MODE, USER_MODE, ALL_MODE, DEFAULT_PAGE_SIZE } from 'modules/mediaLibrary/constants';

import dashboardFiltersReducer from './filters';
import isMediaDrawerVisible from './isMediaDrawerVisible';
import isUploadModalVisible from './isUploadModalVisible';
import loadingReducer from './loading';

const deleteOne = (state, { payload }) => state.filter(id => id !== payload);
const addMany = (state, { payload }) => [...state, ...payload.map(({ id }) => id)];
const resetPage = state => ({ ...state, number: 0, size: DEFAULT_PAGE_SIZE });

/**
 * @typedef {{
 * dashboard: {
 *   DEALER_MODE: import('modules/global/reducers/simpleSearchReducer').SimpleSearchReducer,
 *   GROUP_MODE: import('modules/global/reducers/simpleSearchReducer').SimpleSearchReducer,
 *   USER_MODE: import('modules/global/reducers/simpleSearchReducer').SimpleSearchReducer,
 * },
 * filters: {
 *   DEALER_MODE: import('./filters').MediaLibraryFiltersReducer,
 *   GROUP_MODE: import('./filters').MediaLibraryFiltersReducer,
 *   USER_MODE: import('./filters').MediaLibraryFiltersReducer,
 * },
 * isMediaDrawerVisible: import('./isMediaDrawerVisible').MediaLibraryDrawerReducer,
 * isUploadModalVisible: import('./isUploadModalVisible').UploadModalReducer,
 * loading: import('./loading').MediaLibraryLoadingReducer,
 * }} MediaLibraryUIReducer
 */
export default combineReducers({
  dashboard: combineReducers({
    [DEALER_MODE]: createSearchReducers(FETCH_MEDIA_LIBRARY, {
      global: { matcher: ({ meta }) => meta.source === `dashboard-${DEALER_MODE}` },
      ids: {
        [DELETE_MEDIA_LIBRARY_SUCCESS]: deleteOne,
        [UPLOAD_MEDIA_LIBRARY_ITEMS_SUCCESS]: addMany,
      },
      page: { [SET_MEDIA_LIBRARY_FILTER]: resetPage, [SELECT_DEALER]: resetPage },
    }),
    [GROUP_MODE]: createSearchReducers(FETCH_MEDIA_LIBRARY, {
      global: { matcher: ({ meta }) => meta.source === `dashboard-${GROUP_MODE}` },
      ids: { [DELETE_MEDIA_LIBRARY_SUCCESS]: deleteOne, [UPLOAD_MEDIA_LIBRARY_ITEMS_SUCCESS]: addMany },
      page: { [SET_MEDIA_LIBRARY_FILTER]: resetPage, [SELECT_GROUP]: resetPage },
    }),
    [USER_MODE]: createSearchReducers(FETCH_MEDIA_LIBRARY, {
      global: { matcher: ({ meta }) => meta.source === `dashboard-${USER_MODE}` },
      ids: { [DELETE_MEDIA_LIBRARY_SUCCESS]: deleteOne, [UPLOAD_MEDIA_LIBRARY_ITEMS_SUCCESS]: addMany },
      page: { [SET_MEDIA_LIBRARY_FILTER]: resetPage },
    }),
    [ALL_MODE]: createSearchReducers(FETCH_MEDIA_LIBRARY, {
      global: { matcher: ({ meta }) => meta.source === `dashboard-${ALL_MODE}` },
      ids: { [DELETE_MEDIA_LIBRARY_SUCCESS]: deleteOne, [UPLOAD_MEDIA_LIBRARY_ITEMS_SUCCESS]: addMany },
      page: { [SET_MEDIA_LIBRARY_FILTER]: resetPage },
    }),
  }),
  filters: combineReducers({
    [DEALER_MODE]: dashboardFiltersReducer(DEALER_MODE),
    [GROUP_MODE]: dashboardFiltersReducer(GROUP_MODE),
    [USER_MODE]: dashboardFiltersReducer(USER_MODE),
  }),
  loading: loadingReducer,
  isMediaDrawerVisible,
  isUploadModalVisible,
});
